import { post } from "../../service/api";

const CheckUserPin = async (userId,pin) => {
    try {
        const response = await post(`/user/${userId}/checkPin`, {pin:pin});
        return response;
    } catch (error) {
        console.error('Error CheckUserPin:', error);
        throw error;
    }
};

export default CheckUserPin;